import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {ModalComponent} from "@pb-labs/modal";
import {ButtonType} from "@pb-labs/button";
import {forceUploadVerificationModalActions} from "./const";
import {ForceUploadVerificationModalService} from "./force-upload-verification-modal.service";

@Component({
  selector: "app-force-upload-verification-modal",
  templateUrl: "./force-upload-verification-modal.component.html",
  styleUrls: ["./force-upload-verification-modal.component.scss"],
})
export class ForceUploadVerificationModalComponent implements OnInit, OnDestroy {
  @ViewChild("modal") modal: ModalComponent;

  filename: string;
  readonly forceUploadVerificationModalActions = forceUploadVerificationModalActions;
  readonly buttonType = ButtonType;

  private _destroy$: Subject<void> = new Subject<void>();

  constructor(private forceUploadVerificationModalService: ForceUploadVerificationModalService) {}

  ngOnInit(): void {
    this.forceUploadVerificationModalService.open$.pipe(takeUntil(this._destroy$)).subscribe((filename) => {
      this.modal.open();
      this.filename = filename;
    });

    this.forceUploadVerificationModalService.close$.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this.modal.close();
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();

    this.filename = null;
  }

  onButtonClick(action: forceUploadVerificationModalActions): void {
    this.forceUploadVerificationModalService.verify(action);
  }
}
